import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import VLFModal from "@/components/Modal";
import VLFSelectNew from "@/components/Input/SelectNew";
import VLFTextField from "@/components/Input/TextField";

import {RosterAPI} from "@/api/roster";

import {
	getInternalClubId,
	ERROR_OPERATION,
	SUCCESSFUL_OPERATION,
	REQUIRED_FIELD,
} from "@/utils/constants";
import {getRosterName} from "@/utils/functions";

// Sposta un giocatore da una rosa interna a un'altra (transfer).
// `player` deve avere `id` e `rosterId` (rosa sorgente corrente).
function TransferPlayerModal({open, close, player, onSuccess, handleNotification}) {
	const seasonId = useSelector((state) => state?.season?.id);

	const [rosters, setRosters] = useState([]);
	const [toRoster, setToRoster] = useState(null);
	const [jersey, setJersey] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	useEffect(() => {
		if (!open || !seasonId) return;
		setToRoster(null);
		setJersey("");
		setError(false);
		RosterAPI.list({seasonId, prospect: false, clubId: getInternalClubId()})
			.then((res) => {
				setRosters(
					(res || [])
						.filter(
							(r) => !r.prospect && !r.isPool && r.id !== player?.rosterId,
						)
						.sort((a, b) => getRosterName(a).localeCompare(getRosterName(b)))
						.map((r) => ({value: r.id, label: getRosterName(r)})),
				);
			})
			.catch(() => setRosters([]));
	}, [open, seasonId, player?.rosterId]);

	const handleConfirm = async () => {
		if (!toRoster) {
			setError(true);
			return;
		}
		setLoading(true);
		try {
			await RosterAPI.transferPlayer(player.rosterId, player.id, {
				toRosterId: toRoster.value,
				details: {jerseyNumber: jersey ? Number(jersey) : undefined},
			});
			handleNotification(SUCCESSFUL_OPERATION, "success");
			onSuccess && onSuccess();
			close();
		} catch {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	return (
		<VLFModal
			open={open}
			title="Sposta in un'altra rosa"
			close={close}
			confirm={handleConfirm}
			confirmLabel="Sposta"
			loading={loading}
			content={
				<div className="row no-margin mt-2">
					<div className="col-sm-12 col-md-8 padding-small">
						<VLFSelectNew
							options={rosters}
							value={toRoster}
							onChange={(v) => {
								setError(false);
								setToRoster(v);
							}}
							label="Rosa di destinazione"
							required
							helperText={error ? REQUIRED_FIELD : ""}
							error={error}
						/>
					</div>
					<div className="col-sm-12 col-md-4 padding-small">
						<VLFTextField
							value={jersey}
							onChange={(e) => setJersey(e.target.value)}
							label="Numero maglia"
							size="small"
							type="number"
						/>
					</div>
				</div>
			}
		/>
	);
}

export default TransferPlayerModal;
